// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1R2qj","avatar":"styles__avatar___Hi47C","info":"styles__info___3UsCj","name":"styles__name___29q3_","nameText":"styles__nameText___NRhTi"};